import { toast, ToastOptions, TypeOptions } from 'react-toastify';
import store from 'src/store';

export class S5Toaster {
  error(message: string, options?: ToastOptions) {
    this.toastIfAllowed(options?.type ?? 'error', message, options);
  }

  private toastIfAllowed(type: TypeOptions, message: string, options?: ToastOptions) {
      const isClientFacing = store.getState().appConfig.isClientFacing
    if (isClientFacing) {
      return;
    }

    toast(message, {
      ...options,
      type,
    });
  }
}
